module.exports = "<div class=\"col-sm-10 main\">\n\t<h1 class=\"page-header\">User Event Log</h1>\n\t<h3 class=\"page-header\" style=\"margin-top:30px\">User Session Event Log</h3>\n\t<div style=\"margin-top: 10px\">\n\t\t<div id=\"userSessionGrid\"></div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/users-h/users-h.component.html
// module id = ../../../../../src/app/pages/history/users-h/users-h.component.html
// module chunks = main